var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-links"},[_c('router-link',{attrs:{"to":{ name: 'TransferPolicy' }}},[_vm._v("運送政策")]),_c('router-link',{attrs:{"to":{ name: 'ExchangePolicy' }}},[_vm._v("退換貨政策")]),_c('router-link',{attrs:{"to":{ name: 'DataPolicy' }}},[_vm._v("隱私權保護政策")]),_c('router-link',{attrs:{"to":{ name: 'AntiPhishing' }}},[_vm._v("反詐騙宣導")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }